import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeSixComponent } from './components/pages/home-six/home-six.component';

const routes: Routes = [
  {path: '', component: HomeSixComponent},
  {path: 'home-six', component: HomeSixComponent},
  {path: '**', redirectTo: ''},
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
